import { getLocaleDayNames } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MasterDetailComponent } from '../shared/master-detail/master-detail.component';
import { UcetniJednotkaDataService } from '../ucetni-jednotka-data/ucetni-jednotka-data.service';

@Component({
    selector: 'cml-master-detail',
    templateUrl: './uctovy-rozvrh.component.html',
    styleUrls: ['./uctovy-rozvrh.component.scss'],
    standalone: false
})
export class UctovyRozvrhComponent extends MasterDetailComponent {
  
  uj = this.route.snapshot.params["id"]+ " - ";
  uo = this.route.snapshot.params["kod"];

  constructor(router: Router, route: ActivatedRoute, private ucetniJednotkaDataService: UcetniJednotkaDataService){
    super(route, router);
    this.getName();
  }

  async getName(){
    this.uj += await this.ucetniJednotkaDataService.get(this.route.snapshot.params["id"]).then(x => x.nazev);
  }
}
